import { render, staticRenderFns } from "./TeacherDeleteDialog.vue?vue&type=template&id=222730d6"
import script from "./TeacherDeleteDialog.vue?vue&type=script&lang=js"
export * from "./TeacherDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports